import Dashboard from "./Dashboard";
import NoAccessPage from "./Access";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function HomeResolver() {
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const stored = localStorage.getItem("userPermissions");

    if (stored) {
      setPermissions(JSON.parse(stored));
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (!loading && permissions.length > 0) {
      // Check permissions in priority order and redirect accordingly
      const hasPermission = (perm) => 
        permissions.some((p) => p.trim().toLowerCase() === perm.toLowerCase());

      // Priority order for redirects based on permissions
      if (hasPermission("Evaluation")) {
        // Keep on dashboard if has evaluation permission
        return;
      } else if (hasPermission("User management")) {
        navigate("/user-management", { replace: true });
        return;
      } else if (hasPermission("Role management")) {
        navigate("/role-management", { replace: true });
        return;
      } else if (hasPermission("Learning module")) {
        navigate("/learning-modules", { replace: true });
        return;
      } else if (hasPermission("Report")) {
        navigate("/my-evaluation", { replace: true });
        return;
      }
    }
  }, [permissions, loading, navigate]);

  const hasEvaluation = permissions.some(
    (p) => p.trim().toLowerCase() === "evaluation"
  );

  console.log("HomeResolver permissions:", permissions);
  console.log("Has evaluation:", hasEvaluation);

  if (loading) {
    return <div>Loading...</div>;
  }

  return hasEvaluation ? <Dashboard /> : <NoAccessPage />;
}